<template>
    <div
        v-if="!assignedorderids.includes(order.id)"
        :key="order.id"
        :class="['deliveryItem', { 'notactive': checkifactive(group.date) }]"
    >
        <div class="OrderInfo">
            <div class="itemSize">
                <span class="itemNumber">
                    {{ order.numberofboxes }}
                </span>
                <span class="doz"> DOZ </span>
            </div>

            <div class="orderName">
                <h2>{{ order.contact_name }}</h2>
                <p>
                    <b-icon icon="phone"></b-icon>
                    {{ order.phone_number | VMask("(###) ###-####") }}
                </p>
                <p>
                    <b-icon icon="box"></b-icon> Order# {{ order.order_number }}
                </p>
                <p>
                    <b-icon icon="filter-left"></b-icon>
                    {{
                        order.order_event_time_range ? "Event" : "Subscription"
                    }}
                </p>
            </div>
        </div>

        <div class="deliveryInfo">
            <b-row no-gutters>
                <b-col cols="3" md="2">
                    <div class="googleMap" @click="openMap('point', order)">
                        <GmapMap
                            :options="mapOptions"
                            :center="{
                                lat: parseFloat(
                                    order.shipping_address_latitude
                                ),
                                lng: parseFloat(
                                    order.shipping_address_longitude
                                ),
                            }"
                            :zoom="10"
                            map-type-id="roadmap"
                        >
                            <GmapMarker
                                :icon="svgMarker"
                                :position="{
                                    lat: parseFloat(
                                        order.shipping_address_latitude
                                    ),
                                    lng: parseFloat(
                                        order.shipping_address_longitude
                                    ),
                                }"
                            />
                        </GmapMap>
                    </div>
                </b-col>

                <b-col cols="8" md="8">
                    <div class="deliveryDateandTime">
                        <div class="ddate">
                            <b-icon icon="calendar"></b-icon>
                            {{
                                order.order_event_time_range
                                    ? `${order.order_event_time_range}, `
                                    : ""
                            }}
                            {{ order.delivery_date | formatdate("MMM D") }}
                            <!-- 1:30 - 2:30 PM, Jan 1 -->
                        </div>

                        <div class="dAddress">
                            <b-icon icon="geo-alt"></b-icon>
                            {{ order.shipping_address_street }}
                            {{ order.shipping_address_city }}
                            {{ order.shipping_address_state }}
                            {{ order.shipping_address_zipcode }}
                        </div>
                    </div>
                </b-col>

                <b-col cols="1">
                    <div
                        @click.prevent="
                            $emit('update:assignorder', order),
                            $emit('update:showAssignPop', true)
                        "
                        class="deliverAssign"
                    >
                        <b-icon icon="plus-circle"></b-icon>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
// plugins
import moment from "moment";

// Helpers
import Helper from "@/helpers/helper.js";

// mixins
import {unassignedordermixins} from '@/mixins/unassignedordermixins'

export default {
    mixins : [unassignedordermixins],
    filters: {
        /**
         * Format date by
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : "";
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date);
        },
    },
    methods: {
        /**
         * check order delivery date
         * if not today or tomorrow disable event pointer and grayed out the order
         */
        checkifactive(date) {
            /**
             * Check if pastdue then set active
             */
            console.log('datedate', date)
            if(date == 'pastdue') {
                return false
            }
            /**
             * Check if order is today or tomorrow
             */
            const todaysdate = Helper.isUStimezone()
                ? moment().format("MM/DD/YYYY")
                : Helper.formatdate(moment(), "MM/DD/YYYY");
            if (moment(date).isSame(todaysdate, "day")) {
                return false;
            } else if (
                moment(date).isSame(moment(todaysdate).add(1, "day"), "day")
            ) {
                return false;
            } else {
                return true;
            }
        },
    },
    /**
     * Run function before component render
     */
    async beforeMount() {
        // Google map
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
        });
    },
};
</script>

